import React from "react";
import { useLang } from "../contexts/LanguageContext";

const Process = () => {
  const { t } = useLang();
  const steps = t.process.steps;

  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative bg-[#F3EFE7] py-24 md:py-32 overflow-hidden grain"
    >
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-16">
          <div className="lg:col-span-7 reveal">
            <div className="flex items-center gap-3 mb-6">
              <span className="divider-line" />
              <span className="overline text-[#DE9E36]">{t.process.overline}</span>
            </div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl text-[#1A201C] font-bold leading-[1.1] tracking-tight">
              {t.process.title}
            </h2>
          </div>
        </div>

        <div className="relative">
          {/* Tracing line */}
          <div className="hidden md:block absolute top-12 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#DE9E36]/60 to-transparent" />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
            {steps.map((s, i) => (
              <div
                key={i}
                data-testid={`process-step-${i}`}
                className="reveal relative"
                style={{ transitionDelay: `${i * 80}ms` }}
              >
                {/* Marker */}
                <div className="hidden md:flex absolute -top-3 left-0 w-6 h-6 rounded-full bg-[#DE9E36] ring-4 ring-[#F3EFE7] items-center justify-center">
                  <span className="w-2 h-2 rounded-full bg-[#1A201C]" />
                </div>

                <div className="md:pt-16">
                  <span className="font-mono text-[11px] tracking-[0.3em] text-[#DE9E36]">
                    STEP {s.n}
                  </span>
                  <h3 className="mt-3 text-2xl text-[#1A201C] font-bold tracking-tight">{s.t}</h3>
                  <p className="mt-3 text-sm text-[#4E5750] leading-relaxed">{s.d}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
